import axios from '@/utils/axios';

// 查看用户套餐订单
export function GetPackageOrderDeliver(params) {
    return axios({
        url: '/package/order/deliver',
        method: 'get',
        params,
    });
}

// 提交套餐订单
export function SubmitPackageOrder(params) {
    return axios({
        url: '/package/order/submit',
        method: 'post',
        params,
    });
}

// 套餐订单数量
export function GetPackageOrderTotal(params) {
    return axios({
        url: '/package/order/total',
        method: 'get',
        params,
    });
}

// 套餐订单列表
export function ListPackageOrder(params) {
    return axios({
        url: '/package/order/list',
        method: 'get',
        params,
    });
}

// 套餐订单详情
export function GetPackageOrder(params) {
    return axios({
        url: '/package/order',
        method: 'get',
        params,
    });
}

// 取消套餐订单
export function CancelPackageOrder(params) {
    return axios({
        url: '/package/order/cancel',
        method: 'post',
        params,
    });
}

// 套餐订单剩余商品
export function GetPackageOrderGoods(params) {
    return axios({
        url: '/package/order/goods-remain',
        method: 'get',
        params,
    });
}

export function GetPackageSellOutArea() {
    return axios({
        url: '/package/order/sell-out/area',
        method: 'get'
    })
}